<template>
    <div class="container">
        <a-spin tip="Carregando..." :spinning="spinning">

            <a-breadcrumb separator=">">
                <a-breadcrumb-item>
                    <a href="/vistorias/processar">Vistorias</a>
                </a-breadcrumb-item>
                <a-breadcrumb-item>Vistoriar</a-breadcrumb-item>
            </a-breadcrumb>

            <a-page-header title="Vistoria" :sub-title="header()">
            </a-page-header>


            <a-steps v-model:current="current" type="navigation" :items="steps"></a-steps>
            <a-divider />

            <a-form :model="form" name="basic" layout="vertical" autocomplete="off" @finish="onFinish"
                @finishFailed="onFinishFailed" class="mt-5">
                <div v-if="current === 0">
                    <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                        <a-col class="gutter-row" :span="4">
                            <a-form-item :name="`matricula`">
                                <label class="label">Matricula</label>
                                <a-input v-model:value="form.matricula" :disabled="true"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col class="gutter-row" :span="8">
                            <a-form-item :name="`nome`">
                                <label class="label">Nome</label>
                                <a-input v-model:value="form.nome" :disabled="true"></a-input>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                        <a-col class="gutter-row" :span="8">
                            <a-form-item :name="`setor`">
                                <label class="label">Setor</label>
                                <a-input v-model:value="form.setor" :disabled="true"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col class="gutter-row" :span="8">
                            <a-form-item :name="`quadra`">
                                <label class="label">Quadra</label>
                                <a-input v-model:value="form.quadra" :disabled="true"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col class="gutter-row" :span="8">
                            <a-form-item :name="`lote`">
                                <label class="label">Lote</label>
                                <a-input v-model:value="form.lote" :disabled="true"></a-input>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="30">
                        <a-col class="gutter-row" :span="8">
                            <a-form-item :name="`bairro`">
                                <label class="label">Bairro</label>
                                <a-input v-model:value="form.bairro" :disabled="true"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col class="gutter-row" :span="8">
                            <a-form-item :name="`area`">
                                <label class="label">Área m²</label>
                                <a-input-number v-model:value="form.area" style="width: 100%" :disabled="true" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-divider orientation="left">Características</a-divider>

                    <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                        <template v-for="grupo of grupoLote" :key="grupo.codigo">
                            <a-col :span="8">
                                <a-form-item>
                                    <label class="label"> {{ grupo.descricao }} </label>
                                    <a-select v-model:value="grupo.selected" :name="`field-lote-${grupo.codigo}`"
                                        size="large">
                                        <template v-for="opcoes of grupo.opcoes" :key="opcoes.codigo">
                                            <a-select-option :value="opcoes.codigo">{{ opcoes.descricao
                                                }}</a-select-option>
                                        </template>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                        </template>
                    </a-row>
                </div>

                <template v-for="edificacao of edificacoes" :key="edificacao.codigo">
                    <div v-if="current === edificacao.step">

                        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                            <a-col :span="24">
                                <a-form-item>
                                    <label class="label"> Unidade do e-Cidade</label>
                                    <a-select v-model:value="edificacao.construcao" size="large">
                                        <template v-for="unidade of unidadesExterno" :key="unidade.construcao">
                                            <a-select-option :value="unidade.construcao">Construção: {{
            unidade.construcao }} / {{ unidade.rua }} / {{ unidade.area }}
                                            </a-select-option>
                                        </template>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                        </a-row>

                        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                            <a-col class="gutter-row" :span="8">
                                <a-form-item :name="`logradouro`" :label="`Logradouro`">
                                    <a-input v-model:value="form.logradouro" :disabled="true"></a-input>
                                </a-form-item>
                            </a-col>
                            <a-col class="gutter-row" :span="8">
                                <a-form-item :name="`numero`" :label="`Número`">
                                    <a-input v-model:value="form.numero" :disabled="true"></a-input>
                                </a-form-item>
                            </a-col>
                            <a-col class="gutter-row" :span="8">
                                <a-form-item :name="`complemento`" :label="`Complemento`">
                                    <a-input v-model:value="form.complemento" :disabled="true"></a-input>
                                </a-form-item>
                            </a-col>
                        </a-row>

                        <a-divider orientation="left">Área da Construção</a-divider>

                        <a-row :gutter="30">
                            <a-col class="gutter-row" :span="8">
                                <a-form-item :name="`area_constr`" :label="`Área da Construção M²`"
                                    :rules="[{ required: true, message: 'Informe a área do m²' }]">
                                    <a-input-number v-model:value="form.area_constr" style="width: 100%" :step="0.01" />
                                </a-form-item>
                            </a-col>
                            <a-col class="gutter-row" :span="8">
                                <a-form-item :name="`area_p`" :label="`Área Privada M²`"
                                    :rules="[{ required: true, message: 'Informe a área do m²' }]">
                                    <a-input-number v-model:value="form.area_p" style="width: 100%" :step="0.01" />
                                </a-form-item>
                            </a-col>
                            <a-col class="gutter-row" :span="8">
                                <a-form-item :name="`pavimento`" :label="`Pavimento`"
                                    :rules="[{ required: true, message: 'Informe a medida' }]">
                                    <a-input-number v-model:value="form.pavimento" style="width: 100%" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-divider orientation="left">Características da Construção</a-divider>
                        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                            <template v-for="grupo of edificacao.caracteristicas" :key="grupo.codigo">
                                <a-col :span="8">
                                    <a-form-item>
                                        <label class="label"> {{ grupo.descricao }} </label>
                                        <a-select v-model:value="grupo.selected" :name="`field-lote-${grupo.codigo}`"
                                            size="large">
                                            <template v-for="opcoes of grupo.opcoes" :key="opcoes.codigo">
                                                <a-select-option :value="opcoes.codigo">{{ opcoes.descricao
                                                    }}</a-select-option>
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                            </template>
                        </a-row>
                    </div>
                </template>
            </a-form>

            <div class="steps-action">
                <a-button v-if="current < steps.length - 1" type="primary" @click="next">Próximo</a-button>
                <a-button v-if="current == steps.length - 1" type="primary" :icon="h(SaveOutlined)"
                    @click="message.success('Processing complete!')">
                    Finalizar
                </a-button>
                <a-button v-if="current > 0" style="margin-left: 8px" @click="prev">Voltar</a-button>
            </div>

            <a-float-button-group shape="circle">
                <a-float-button @click="showDrawer">
                    <template #icon>
                        <SettingOutlined />
                    </template>
                </a-float-button>
            </a-float-button-group>

            <a-drawer title="Configurações" :size="size" :open="open" @close="onClose">
            </a-drawer>

        </a-spin>
    </div>
</template>
<script setup>
import { ref, h, onMounted } from 'vue';
import { SaveOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons-vue';

const open = ref(false);
const size = ref('default');
const spinning = ref(false);

const props = defineProps(["matricula", "data"]);

const steps = ref([
    {
        title: 'Lote',
    }
]);

const edificacoes = ref([]);

const unidadesExterno = ref([]);

const current = ref(0);

const header = () => {
    return `#Matricula ${props.matricula} vistoriado em ${new Date(props.data).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}`;
}

const next = () => {
    current.value++;
}

const prev = () => {
    current.value--;
}

const grupoLote = ref([]);

const form = ref({
    setor: null,
    quadra: null,
    lote: null,
    bairro: null,
    area: null,
    areal: null,
    logradouro: null,
    numero: null,
    complemento: null
});

const showDrawer = () => {
    open.value = true;
};

const onClose = () => {
    open.value = false;
};

const value3 = ref('b');

const onFinish = (values) => {
    console.log('Success:', values);
};

const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
};

onMounted(async () => {

    if (props.data && props.matricula) {

        spinning.value = true;
        const response = await window.axios.get(`vistorias/vistoriar/${props.matricula}/${props.data}`);
        spinning.value = false;

        if (response.status == 200) {
            let data = response.data;
            form.value.setor = data.dados.j34_setor;
            form.value.quadra = data.dados.j34_quadra;
            form.value.lote = data.dados.j34_lote;
            form.value.bairro = data.dados.j14_nome;
            form.value.area = data.dadosGeral.lote.area;
            form.value.matricula = data.dados.j01_matric;
            form.value.nome = data.dados.z01_nomecomple;
            mountGrupoLote(objectToArray(response.data.loteGrupo));
            unidadesExterno.value = data.unidades.edificacoes;
            response.data.edificacoesGrupo.forEach((edificacao, index) => {

                let codigo = index + 1;
                steps.value.push({
                    title: `Construção ${codigo}`
                });

                edificacoes.value.push({
                    codigo: codigo,
                    caracteristicas: mountGrupoConstrucao(objectToArray(edificacao)),
                    step: steps.value.length - 1
                });
            });
        }
    }
})

const mountGrupoLote = (grupos) => {
    grupos.forEach((grupo, index) => {
        let opcoes = objectToArray(grupo.opcoes);

        grupoLote.value.push({
            codigo: grupo.codigo,
            descricao: grupo.descricao,
            opcoes: opcoes,
            selected: getSelectedGroup(opcoes)
        });
    });
}

const mountGrupoConstrucao = (grupos) => {
    let caracteristicas = [];
    grupos.forEach((grupo, index) => {
        let opcoes = objectToArray(grupo.opcoes);

        caracteristicas.push({
            codigo: grupo.codigo,
            descricao: grupo.descricao,
            opcoes: opcoes,
            selected: getSelectedGroup(opcoes)
        });
    });

    return caracteristicas;
}

const objectToArray = (object) => {

    if (typeof object === 'object') {
        return Object.keys(object).map((key) => object[key]);
    }
    return object;
}

const getSelectedGroup = (opcoes) => {
    let value = null;
    opcoes.forEach((opcao, index) => {
        if (opcao.hasOwnProperty('vistoriado')) {
            value = opcao.codigo;
        }
    });
    return value;
}

</script>

<style scoped>
.label {
    font-size: 12px !important;
    font-weight: bolder;
}

.steps-action {
    margin-top: 15px;
    text-align: right;
}

.anticon {
    vertical-align: 0 !important;
}
</style>
